import React from 'react';
import TableCell from '@mui/material/TableCell';
import { blueGrey } from '@mui/material/colors';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const AccordionCell = ({...props}) => {

  return (
    <React.Fragment>
        <TableCell align="center" style={{ color: "white" }}>
          {props.isOpen === props.row.id ? 
            <KeyboardArrowDownIcon 
              sx={{ color: blueGrey[800] }}
              style={{ cursor: 'pointer' }}
              onClick={props.isUserOrderOpen}
              /> 
              :
            <KeyboardArrowRightIcon 
              sx={{ color: blueGrey[800] }} 
              style={{ cursor: 'pointer' }}
              onClick={() => props.openUserProducts(props.row.id)}
              />
            }
        </TableCell>
    </React.Fragment>
  );
};

export default AccordionCell;
